/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Faq_Desktop_QInputs */

const en_mk_faq_desktop_q = /** @type {(inputs: Mk_Faq_Desktop_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Do I need Desktop? Are Windows and macOS versions available?`)
};

const id_mk_faq_desktop_q = /** @type {(inputs: Mk_Faq_Desktop_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Harus memasang Desktop? Ada versi Windows dan macOS?`)
};

/**
* | output |
* | --- |
* | "Do I need Desktop? Are Windows and macOS versions available?" |
*
* @param {Mk_Faq_Desktop_QInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_faq_desktop_q = /** @type {((inputs?: Mk_Faq_Desktop_QInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Faq_Desktop_QInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_faq_desktop_q(inputs)
	return en_mk_faq_desktop_q(inputs)
});